import { ApolloProvider } from "@apollo/client";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { apolloClient } from "./config";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import { AppContextProvider } from "./utils/AppContextProvidet";
import { ArticleTableViewController } from "./views/Article/List/Controller";
import { ArticleViewController } from "./views/Article/View/Controller";
import { ArticleCategoryViewController } from "./views/ArticleCategory/Controller";
import { ArticleCategoryListView } from "./views/ArticleCategory/ListView";
import { ArticleListViewController } from "./views/ArticleListView/Controller";
import { ArticleSourceListView } from "./views/ArticleSources/ListView";
import { CustomerListView } from "./views/Customer/List/ListView";
import { Dashboard } from "./views/Dashboard";
import { DistributorListView } from "./views/Distributor/ListView";
import { FootprintListView } from "./views/Footprint/ListView";
import { LocationListView } from "./views/Location/ListView";
import { ProductGroupListView } from "./views/ProductGroup/ListView";
import { CreateCustomerOrderViewController } from "./views/Store/CustomerOrder/View/CreateView";
import { AllCustomerOrderListView } from "./views/Store/CustomerOrder/List/ListView";
import { CustomerOrderViewController } from "./views/Store/CustomerOrder/View/OrderView";
import { Template } from "./views/Template";
import { UserListView } from "./views/Users/List/ListView";
import {
  ProfileView,
  UserProfileViewController,
} from "./views/Users/Profile/profile";
import { ScanView } from "./views/Tools/Scan/Scan";
import { LCSCLookup } from "./views/Tools/LCSC";

ReactDOM.render(
  <Router>
    <ApolloProvider client={apolloClient}>
      <AppContextProvider>
        <Template>
          <Switch>
            <Route path="/footprints" exact>
              <FootprintListView />
            </Route>
            <Route path="/locations" exact>
              <LocationListView />
            </Route>
            <Route path="/product-groups" exact>
              <ProductGroupListView />
            </Route>
            <Route path="/articles/categories" exact>
              <ArticleCategoryListView />
            </Route>
            <Route path="/articles/sources" exact>
              <ArticleSourceListView />
            </Route>
            <Route path="/articles/all" exact>
              <ArticleTableViewController />
            </Route>
            <Route path="/articles/view" exact>
              <ArticleListViewController />
            </Route>
            <Route path="/distributors" exact>
              <DistributorListView />
            </Route>
            <Route
              path="/article/category/:id"
              component={ArticleCategoryViewController}
              exact
            />
            <Route path="/" exact>
              <Dashboard />
            </Route>
            <Route
              path="/articles/:id"
              component={ArticleViewController}
              exact
            />
            <Route path="/customer/order/new" exact>
              <CreateCustomerOrderViewController />
            </Route>
            <Route path="/customer/orders" exact>
              <AllCustomerOrderListView />
            </Route>
            <Route
              path="/customer/order/:id"
              component={CustomerOrderViewController}
              exact
            />
            <Route path="/customers" exact>
              <CustomerListView />
            </Route>
            <Route path="/users" exact>
              <UserListView />
            </Route>
            <Route
              path="/user/:id"
              component={UserProfileViewController}
              exact
            />
            <Route path="/me" exact>
              <ProfileView />
            </Route>
            <Route path="/tools/scan" exact>
              <ScanView />
            </Route>
            <Route path="/tools/lcsc" exact>
              <LCSCLookup />
            </Route>
          </Switch>
        </Template>
      </AppContextProvider>
    </ApolloProvider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
